// extracted by mini-css-extract-plugin
export const root = "fc-content-block-module--root--1kyVD";
export const right = "fc-content-block-module--right--1FrED";